import { render } from "./Support.vue?vue&type=template&id=4de125be"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
script.render = render

export default script